import React from 'react';
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next';
import { StaticImage } from 'gatsby-plugin-image';

import './achievements.less';

const Achievements = () => {
  const { t } = useTranslation();
  return (
    <div className="o-investors">
      <div className="m-globalContentContainer">
        <div className="m-investors__container">
          <div className="m-investors__banner m-investors__combinig">
            <p className="m-investors__text__brand_2 m-investors__text__brand_2_bigger --right">
              <Trans i18nKey="web.ivestors.invest.achievements.title" />
            </p>
            <h2 className="m-investors__text__title m-investors__achievements__title --no-border --right">
              <Trans i18nKey="web.ivestors.invest.achievements.sub.title" />
            </h2>
            <div className="m-investors__banner m-investors__centered">
              <span className="m-investors__image m-achievements__image">
                <StaticImage
                  src="../../../images/investments/Graph_10.svg"
                  alt={t('images.graph.10.alt')}
                  title={t('images.graph.title')}
                  className="a-investors__range_image a-investors__banner_image"
                  objectFit="contain"
                  width={1038}
                  height={407}
                />
              </span>
              <span className="m-investors__text">
                <p className="m-investors__text__brand m-investors__achievements__text__brand m-investors__text__brand_small">
                  <>
                    <br />
                    <br />
                    <Trans i18nKey="web.ivestors.invest.achievements.text" />
                  </>
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Achievements;
